
class DateTimeFormat {
    static DATE_TIME_REGEXP_SEPARATOR = '___';
}

export default DateTimeFormat;
